import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import TextfieldNumberSPF from "../../../components/textfields/textfield.number.spf";
import {useSnackbar} from "notistack";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Constitution de servitude(s) dans un acte de vente (si disposition indépendante)
// simulateur Id 34

function Simulateur_34(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const { enqueueSnackbar } = useSnackbar();

  const [departement, setDepartement] = useState(0);
  const [nombre_servitude, setNbServitude] = useState(0);
  const [prix_acte, setPrixActe] = useState(0);
  const [prixServitude, setPrixServitude] = useState([]);
  const [valeur_servitude, setValeurServitude] = useState(0);
  const [facturation_forfait, setForfait] = useState(0);
  const [nombre_forfait, setNbForfait] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
      setInRedux(setter, value);
    }
    if (setter === setNbServitude && value >= 10) {
      setNbServitude(10);
      setInRedux(setNbServitude, 10);
      enqueueSnackbar('La quantité maximale de servitudes est de 10', {
        variant: 'warning'
      });
    } else {
      setter(value);
      setInRedux(setter, value, key);
    }
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  useEffect(() => {
    const updateServitudes = () => {
        if (nombre_servitude >= 1) {
            if (prixServitude.length < nombre_servitude) {
                let handle = [];
                for (let i = 0; i < prixServitude.length; i++) {
                    handle[i] = prixServitude[i];
                }
                for (let i = prixServitude.length; i < nombre_servitude; i++) {
                    handle[i] = {};
                }
                handleChange(setPrixServitude, handle);
            } else {
                const newPrixServitude = [...prixServitude];
                newPrixServitude.splice(parseInt(nombre_servitude));
                handleChange(setPrixServitude, newPrixServitude);
            } 
        } else {
            handleChange(setPrixServitude, []);
        }
    };
    updateServitudes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nombre_servitude]);

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          nombre_servitude: parseInt(nombre_servitude),
          prix_acte: parseInt(prix_acte),
          valeur_servitude: parseInt(valeur_servitude),
          facturation_forfait: parseInt(facturation_forfait),
          nombre_forfait: parseInt(nombre_forfait),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
        dependances: prixServitude,
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0);
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }
      if (setter === setNbServitude) { 
        Object.assign(object["inputs"], { nombre_servitude: parseInt(value) }); 
      }
      if (setter === setPrixActe) { 
        Object.assign(object["inputs"], { prix_acte: parseInt(value) }); 
      }
      if (setter === setPrixServitude) { 
        object.dependances = value; 
      }
      if (setter === setValeurServitude) { 
        Object.assign(object["inputs"], { valeur_servitude: parseInt(value) }); 
      }

      if (setter === setForfait) {
        if (value === 0) {
          setNbForfait(0);
          Object.assign(object["inputs"], { facturation_forfait: parseInt(value) });
          Object.assign(object["inputs"], { nombre_forfait: 0 });
        } else {
          Object.assign(object["inputs"], { facturation_forfait: parseInt(value) });
        }
      }

      if (setter === setNbForfait) { 
          Object.assign(object["inputs"], { nombre_forfait: parseInt(value) }); 
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) { 
          Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); 
      }
      if (setter === props.setObjectConventionHonoraires) { 
          Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); 
      }
      if (setter === props.setMontantConventionHonoraires) { 
          Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); 
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    }
  }

  function functionSetPrixServitude(index, value) {
    let formatedData = {
      prix_servitude: parseInt(value),
    };
    prixServitude[index] = formatedData;
    setInRedux(setPrixServitude, prixServitude);
  }

  const renderPrixChamps = () => {
    if (prix_acte === 1) {
        return prixServitude.map((valeur, index) => (
            <div style={styles.cardRowChild} key={index}>
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>Indiquer le prix de la servitude n° {index + 1} :</div>
                    <TextfieldNumberSPF
                        index={index}
                        placeholder="Indiquer la valeur"
                        functionSetValeurs={functionSetPrixServitude}
                    />
                </div>
            </div>
        ));
    } else {
        return (
            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Quelle est la valeur estimée de la servitude ou des servitudes à créer ?
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer la valeur"}
                    setter={setValeurServitude}
                />
            </div>
        );
    }
  };

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Acte tarifé au titre du Tableau 5, n°92 et 93 (Art A444-115). Attention, aucune perception d’émolument n’est
          due s’il s’agit d’un rappel de servitude. Si disposition dépendante, prévoir minimum 15 euros de CSI de
          publication supplémentaire, par constitution de servitude.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Combien y a-t-il de servitudes à créer ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le nombre"}
            setter={setNbServitude}
            max={"10"}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Y a-t-il un prix exprimé dans l’acte ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPrixActe} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {renderPrixChamps()}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Est-il prévu la facturation de plusieurs forfaits de formalité (Article 194 du Tableau 5) ?
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setForfait} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>
        {parseInt(facturation_forfait) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Indiquer le nombre :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le nombre"}
              setter={setNbForfait}
            />
          </div>
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_34;